// extracted by mini-css-extract-plugin
export default {"logo_wrapper":"Hero_logo_wrapper__GCQ5+","logo":"Hero_logo__FWaJ6","attack":"Hero_attack__K5V68","content":"Hero_content__LF09L"};